import {useParams} from 'react-router-dom';

import {Grid} from '@mantine/core';

import {RecordForm} from '../forms/RecordForm';

import {
    FormPageLayout,
    PlatformLoader,
    SimplePageContentWrapper,
    TabbedComponent,
    TabComponentTab
} from '@flexinet/ui-components';
import {Profile} from '../profile/Profile';

import {EditPageNavigation} from '../navigation/EditPageNavigation';
import {usePaymentIntent} from '../hooks/usePaymentIntent';
import {useEditPageTools} from '../hooks/useEditPageTools';

import {AddPage as CheckoutPage} from '../../payments/pages/AddPage';

export const EditPage = () => {

    const {id: paymentIntentId} = useParams();

    if (typeof paymentIntentId === 'undefined') {
        throw new Error('paymentIntentId is required parameter');
    }

    const {
        mode,
        tools,
    } = useEditPageTools();

    const {
        record: paymentIntent,
        loading,
        updateRecord,
    } = usePaymentIntent(paymentIntentId);

    if (loading || !paymentIntent) {
        return <PlatformLoader message='Loading paymentIntent...Please wait'/>;
    }

    const tabs = [{
        title: 'General',
        component: <CheckoutPage paymentIntent={paymentIntent}/>
    }] as TabComponentTab[]

    return (
        <FormPageLayout
            title={paymentIntent.description ? paymentIntent.description : paymentIntent.id}
            pageNavigation={<EditPageNavigation component={paymentIntent}/>}
            tools={tools}
        >


            {mode === 'view' ?
                <Grid>
                    <Grid.Col span={{
                        base: 12,
                        lg: 4
                    }}>
                        <Profile record={paymentIntent}/>
                    </Grid.Col>
                    <Grid.Col span={{
                        base: 12,
                        lg: 8
                    }}>

                        <SimplePageContentWrapper>
                            <TabbedComponent tabs={tabs}/>
                        </SimplePageContentWrapper>

                    </Grid.Col>
                </Grid>

                :
                <SimplePageContentWrapper>
                    <RecordForm
                        record={paymentIntent}
                        handleSubmit={updateRecord}
                    />
                </SimplePageContentWrapper>
            }


        </FormPageLayout>
    );
};
